import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getSipvalues } from "../../../store/actions";
import DisplaySimpleCards from "./displaySimpleCards";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CustomLoading from "../CustomLoader";
import {
  FlashAutoOutlined,
  SignalCellularNullOutlined,
  SignalCellularNullRounded,
} from "@material-ui/icons";
import Paper from "@material-ui/core/Paper";
import { active_columns, pending_columns } from "../../forms/content";
import CustomLoader from "../../forms/Loader";
import { FormatCurrency } from "../currencyFormatter";
import Image from "../../Image";
export class SipTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      open: { active: true, pending: false },
      sipvalues: {
        sipvalue: "",
        currentsips: "",
        monthlyI: "",
        USM: "",
        USMA: "",
      },
    };
  }
  async componentDidMount() {
    const params = {
      arn: this.props.token,
      Tran_flag: "D",
    };
    const response = await this.props.getSipvalues(params);
    const {
      sip_value,
      current_sips,
      monthly_installments,
      upcoming_sips,
      upcoming_sip_maturity_amount,
    } = response.DtData[0];
    this.setState({
      sipvalues: {
        sipvalue: sip_value,
        currentsips: current_sips,
        monthlyI: monthly_installments,
        USM: upcoming_sips,
        USMA: upcoming_sip_maturity_amount,
      },
    });
    if (this.state.open.active) {
      const params = {
        arn: this.props.token,
        Tran_flag: "A",
      };
      await this.props.getSipvalues(params);
    }
    if (this.state.open.pending) {
      const params = {
        arn: this.props.token,
        Tran_flag: "P",
      };
      await this.props.getSipvalues(params);
    }
  }
  Active = async () => {
    this.setState({
      open: { active: true, pending: false },
    });
    const params = {
      arn: this.props.token,
      Tran_flag: "A",
    };
    await this.props.getSipvalues(params);
  };
  PendingAndRejected = async () => {
    this.setState({
      open: { active: false, pending: true },
    });
    const params = {
      arn: this.props.token,
      Tran_flag: "P",
    };
    await this.props.getSipvalues(params);
  };

  render() {
    return (
      <>
        <div className="transaction_sec">
          <div className="simple-card-div" style={{ flexWrap: "wrap" }}>
            <DisplaySIPCards
              name="SIP Value"
              style={{ marginTop: 10 }}
              count={
                !!this.state.sipvalues.sipvalue
                  ? this.state.sipvalues.sipvalue
                  : 0
              }
              currencyformat={true}
              Image={"/images/sip_icon.png"}
            />
            <DisplaySIPCards
              name="Current SIP's"
              style={{ marginTop: 10 }}
              count={
                !!this.state.sipvalues.currentsips
                  ? this.state.sipvalues.currentsips
                  : 0
              }
              onClick={15}
              Image={"/images/current-sip_icon.png"}
            />
            <DisplaySIPCards
              name="Monthly Installments"
              style={{ marginTop: 10 }}
              count={
                !!this.state.sipvalues.monthlyI
                  ? this.state.sipvalues.monthlyI
                  : 0
              }
              currencyformat={true}
              Image={"/images/monthly_icon.png"}
            />
            <DisplaySIPCards
              name="Upcoming Sip Maturity"
              style={{ marginTop: 10 }}
              count={!!this.state.sipvalues.USM ? this.state.sipvalues.USM : 0}
              Image={"/images/upcoming_sip_icon.png"}
            />
            <DisplaySIPCards
              name="Upcoming Sip Maturity Amount"
              style={{ marginTop: 10 }}
              count={
                !!this.state.sipvalues.USMA ? this.state.sipvalues.USMA : 0
              }
              currencyformat={true}
              Image={"/images/upcoming_amount_sip_icon.png"}
            />
          </div>
          <div className="transaction-summary-responsive-page">
            <div
              className="tab-container"
              style={{
                justifyContent: "space-between",
                margin: "25px 20px 15px 20px",
              }}
            >
              <div
                className={!!this.state.open.active ? "tabs-active" : "tabs"}
                onClick={this.Active}
              >
                Active
              </div>
              <div
                className={!!this.state.open.pending ? "tabs-active" : "tabs"}
                onClick={this.PendingAndRejected}
              >
                Pending/Rejected
              </div>
            </div>
          </div>
          {this.props.count > 0 && this.state.open.active ? (
            <CustomLoading />
          ) : this.props.sipTransactions.length >= 1 &&
            this.state.open.active ? (
            <div>
              <Paper className="trasaction-summary-responsive sip_trasaction-summary">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: 20,
                    marginBottom: 0,
                  }}
                />
                <Table>
                  {/* <TableHead> */}
                  <TableRow>
                    {active_columns.map((c) => (
                      <TableCell
                        key={c.key}
                        style={{
                          padding: "15px 10px 5px 10px",
                          color: "white",
                          fontSize: 15,
                          fontFamily: "OpenSans-SemiBold",
                          backgroundColor: "#007ac8",
                        }}
                      >
                        <p
                          className="table_header_text"
                          style={{
                            marginBottom: "2px",
                            wordWrap: "initial",
                            fontSize: "13px",
                          }}
                        >
                          {c.name}
                        </p>
                        <p
                          className="table_sub_header_text"
                          style={{ fontSize: "10px", wordWrap: "initial" }}
                        >
                          {c.subtitle}
                        </p>
                      </TableCell>
                    ))}
                  </TableRow>
                  {/* </TableHead> */}
                  <TableBody>
                    {this.props.sipTransactions.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell className="table-cell ">
                          {item.invname}
                        </TableCell>

                        <TableCell className="table-cell table-values">
                          {item.Scheme}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.folio_number}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.Number_of_Installments}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.Start_Date_of_SIP}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.End_Date_of_SIP}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {!!item.amount ? (
                            <FormatCurrency value={item.amount} />
                          ) : (
                            0
                          )}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.Mode_of_Registration}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.URN_UMRNumber}
                        </TableCell>
                        {/* <TableCell
                                                    className="table-cell table-values"

                                                >
                                                    {item.Status_of_Registration}
                                                </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
              <div>
                {this.props.sipTransactions.map((item, index) => (
                  <InvestorTableCardActive
                    key={index}
                    invName={item.invname}
                    Scheme={item.Scheme}
                    folio_number={item.folio_number}
                    Number_of_Installments={item.Number_of_Installments}
                    Start_Date_of_SIP={item.Start_Date_of_SIP}
                    End_Date_of_SIP={item.End_Date_of_SIP}
                    amount={item.amount}
                    Mode_of_Registration={item.Mode_of_Registration}
                    URN_UMRNumber={item.URN_UMRNumber}
                    active={this.state.open.active}
                  />
                ))}
              </div>
            </div>
          ) : (
            this.props.count == 0 &&
            this.props.sipTransactions.length == 0 &&
            this.state.open.active && (
              <div className="text-center p-4">No Data Found</div>
            )
          )}
          {this.props.count > 0 && this.state.open.pending ? (
            <CustomLoading />
          ) : this.props.sipTransactions.length >= 1 &&
            this.state.open.pending ? (
            <div>
              <Paper className="trasaction-summary-responsive sip_trasaction-summary sip_pending_trasaction">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: 20,
                    marginBottom: 0,
                  }}
                />
                <Table>
                  <TableRow>
                    {pending_columns.map((c) => (
                      <TableCell
                        style={{
                          padding: "15px 10px 5px 15px",
                          color: "white",
                          fontSize: 15,
                          fontFamily: "OpenSans-SemiBold",
                          backgroundColor: "#007ac8",
                        }}
                        key={c.key}
                      >
                        <p
                          className="table_header_text"
                          style={{ marginBottom: "2px", fontSize: "13px" }}
                        >
                          {c.name}
                        </p>
                        <p style={{ fontSize: "10px" }}>{c.subtitle}</p>
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableBody>
                    {this.props.sipTransactions.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell className="table-cell">
                          {item.invname}
                        </TableCell>

                        <TableCell className="table-cell table-values">
                          {item.Scheme}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.folio_number}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {!!item.amount ? (
                            <FormatCurrency value={item.amount} />
                          ) : (
                            0
                          )}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.Mode_of_Registration}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.Rejection_Reason}
                        </TableCell>
                        <TableCell className="table-cell table-values">
                          {item.URN_UMRNumber}
                        </TableCell>
                        {/* <TableCell
                                                className="table-cell table-values"

                                            >
                                                {item.Status_of_Registration}
                                            </TableCell> */}
                        <TableCell className="table-cell table-values">
                          {item.status}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
              <div>
                {this.props.sipTransactions.map((item, index) => (
                  <InvestorTableCardActive
                    key={index}
                    invName={item.invname}
                    Scheme={item.Scheme}
                    folio_number={item.folio_number}
                    amount={item.amount}
                    Mode_of_Registration={item.Mode_of_Registration}
                    URN_UMRNumber={item.URN_UMRNumber}
                    status={item.status}
                    Rejection_Reason={item.Rejection_Reason}
                    pending={this.state.open.pending}
                  />
                ))}
              </div>
            </div>
          ) : (
            this.props.count == 0 &&
            this.props.sipTransactions.length == 0 &&
            this.state.open.pending && (
              <div className="text-center p-4">No Data Found</div>
            )
          )}
        </div>
      </>
    );
  }
}

export default connect(
  ({ authReducer, transactions, loading }) => {
    const { token } = authReducer;
    const { sipTransactions } = transactions;
    const { count } = loading;
    return {
      token,
      sipTransactions,
      count,
    };
  },
  {
    getSipvalues,
  }
)(SipTransactions);
var CurrencyFormat = require("react-currency-format");
export class DisplaySIPCards extends Component {
  render() {
    return (
      <div
        className="col-xl-4 col-lg-4"
        style={{
          padding: "10px",
        }}
      >
        <Card
          className=""
          style={{
            padding: "15px",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div className="sip_display_card_img_sec">
            <Image
              src={this.props.Image}
              alt={this.props.name}
              style={{ height: "45px" }}
            />
          </div>
          <div style={{ marginLeft: "20px" }}>
            <div className="simple-display-card-name-sip">
              {this.props.name}
            </div>
            {this.props.count >= 0 && this.props.currencyformat ? (
              <div className="simple-display-card-name-count">
                <CurrencyFormat
                  value={this.props.count}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"₹"}
                  thousandSpacing="2s"
                  decimalScale={0}
                />
              </div>
            ) : this.props.count >= 0 ? (
              <div className="simple-display-card-name-count">
                <CurrencyFormat
                  value={this.props.count}
                  displayType={"text"}
                  thousandSeparator={true}
                  thousandSpacing="2s"
                  decimalScale={0}
                />
              </div>
            ) : (
              <CustomLoading width={25} height={25} type="ThreeDots" />
            )}
          </div>
        </Card>
      </div>
    );
  }
}
export class InvestorTableCardActive extends Component {
  render() {
    const {
      invName,
      Scheme,
      folio_number,
      Number_of_Installments,
      Start_Date_of_SIP,
      End_Date_of_SIP,
      amount,
      Mode_of_Registration,
      URN_UMRNumber,
      Rejection_Reason,
      status,
      active,
      pending,
      Maturity_Date,
      fmp,
    } = this.props;
    return (
      <div className="mobile_sip_sec">
        <div className="sip_mobile_heading">
          <h2>{invName}</h2>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="investor_name">
              <h2>Scheme </h2>
              <span> :</span>
              <h3>{!!Scheme ? Scheme : "NA"}</h3>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="investor_name">
              <h2> Folio Number</h2>
              <span> :</span>
              <h3> {folio_number}</h3>
            </div>
          </div>
          {fmp && (
            <div className="col-sm-6">
              <div className="investor_name">
                <h2> Maturity Date</h2>
                <span> :</span>
                <h3> {Maturity_Date}</h3>
              </div>
            </div>
          )}
          {active && (
            <>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2> Number of Installments</h2>
                  <span> :</span>
                  <h3> {Number_of_Installments}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2>Start Date of SIP</h2>
                  <span> :</span>
                  <h3>{Start_Date_of_SIP}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2> End Date of SIP</h2>
                  <span> :</span>
                  <h3>{End_Date_of_SIP}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2>Mode of Registration</h2>
                  <span> :</span>
                  <h3>{Mode_of_Registration}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2> Bill Id Number</h2>
                  <span> :</span>
                  <h3>{URN_UMRNumber}</h3>
                </div>
              </div>
            </>
          )}
          <div className="col-sm-6">
            <div className="investor_name">
              <h2>
                Amount <span>:</span>
              </h2>
              <h3>
                <FormatCurrency value={amount} />
              </h3>
            </div>
          </div>
          {pending && (
            <>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2>Mode of Registration</h2>
                  <span> :</span>
                  <h3>{Mode_of_Registration}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2>Rejection Reason</h2>
                  <span> :</span>
                  <h3>{Rejection_Reason}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2> Bill Id Number</h2>
                  <span> :</span>
                  <h3>{URN_UMRNumber}</h3>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="investor_name">
                  <h2> Status</h2>
                  <span> :</span>
                  <h3>{status}</h3>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
